import React from 'react'

const Docs = () => {
    return (
        <svg 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full"
        >
            {/* Document background */}
            <path 
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" 
                fill="#4285F4" 
                stroke="#4285F4" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            {/* Document corner fold */}
            <polyline 
                points="14,2 14,8 20,8" 
                fill="#3367D6"
                stroke="#3367D6" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            {/* Document lines */}
            <line 
                x1="8" 
                y1="13" 
                x2="16" 
                y2="13" 
                stroke="white" 
                strokeWidth="1.5" 
                strokeLinecap="round"
            />
            <line 
                x1="8" 
                y1="17" 
                x2="14" 
                y2="17" 
                stroke="white" 
                strokeWidth="1.5" 
                strokeLinecap="round"
            />
        </svg>
    )
}

export default Docs